import React from 'react';
import VideoBlock from './VideoBlock';
import { MediaPlaybackFields } from '../../../puck/fields/MediaPlaybackFields';
import { detectEmbedProvider } from '../../../media/embedProviders';
import { getMediaSrc } from '../../../media/mediaSource';
import VideoChaptersField from './VideoChaptersField';
import VideoSourceField from './VideoSourceField';
import { puckPxWidthField } from '../../../puck/fields/puckPxWidthField';
import { puckMediaAspectRatioField } from '../../../media';
import { puckSectionField, puckStyleGallerySectionField } from '../../../puck/fields/puckSectionField';
import { puckThemeStyleField } from '../../../puck/fields/ThemeStyleSelectField';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import { puckTextRolesField } from '../../../puck/fields/TextRolesField';
import { withThemedFieldValues } from '../../../puck/fields/themedFieldValues';
import { themedBlockProps, themedBlockResolveData, themedBlockResolveFields } from '../../../puck/themedBlocks';
import { styleDefaults, styleKeys } from '../../../../shared/theme/styleSchema';
import { VIDEO_STYLE_SCHEMA } from './videoStyleSchema';
import { puckHorizontalAlignField } from '../../../puck/fields/puckHorizontalAlignField';
import { puckVerticalAlignField } from '../../../puck/fields/puckVerticalAlignField';

const videoBlockConfig = {
  label: 'Vidéo',
  defaultProps: {
    src: '',
    chapters: [],
    ...styleDefaults(VIDEO_STYLE_SCHEMA),
    alignment: 'center',
    width: undefined,
    mediaAspectRatio: 'auto',
    playback: { controls: true, autoplay: false, loop: false, muted: false },
  },
  fields: withThemedFieldValues('video', {
    _section1: puckSectionField('Média'),
    src: { type: 'custom', label: 'Vidéo', render: (props) => <VideoSourceField {...props} /> },
    playback: {
      type: 'custom',
      label: 'Lecture',
      render: ({ value, onChange }) => (
        <MediaPlaybackFields playback={value} onPatch={onChange} />
      ),
    },
    mediaAspectRatio: puckMediaAspectRatioField,
    _sectionChapters: puckSectionField('Chapitres'),
    chapters: { type: 'custom', label: 'Chapitres', render: (props) => <VideoChaptersField {...props} /> },

    _sectionGallery: puckStyleGallerySectionField('Vidéo'),
    themeStyleId: puckThemeStyleField('video'),
    _sectionChapterStyle: puckSectionField('Présentation des chapitres'),
    chapterLayout: {
      type: 'select', label: 'Disposition des chapitres',
      options: [{ label: 'Liste verticale', value: 'list' }, { label: 'Pastilles horizontales', value: 'pills' }],
    },
    chapterAccent: puckColorField('Couleur d’accent'),
    chapterTextStyles: puckTextRolesField([{ key: 'title', label: 'Titre des chapitres' }, { key: 'time', label: 'Temps des chapitres' }]),
    _section2: puckSectionField('Affichage'),
    /* La prop garde son nom — du contenu en production s'appuie dessus. Seul
       le champ rejoint celui des autres blocs. */
    alignment: puckHorizontalAlignField('Alignement horizontal'),
    alignVertical: puckVerticalAlignField(),
    width: puckPxWidthField('Largeur'),

  }),
  resolveData: themedBlockResolveData('video'),
  resolveFields: (data, { fields }) => {
    const src = getMediaSrc(data.props?.src);
    const styledFields = themedBlockResolveFields('video')(data, { fields });
    if (src && !detectEmbedProvider(src)) return styledFields;
    const hidden = ['chapters', '_sectionChapters'];
    if (src) hidden.push(...styleKeys(VIDEO_STYLE_SCHEMA, ['gallery', 'theme']), 'themeStyleId', '_sectionGallery', '_sectionChapterStyle');
    return Object.fromEntries(Object.entries(styledFields).filter(([key]) => !hidden.includes(key)));
  },
  render: (props) => <VideoBlock {...themedBlockProps('video', props, props.puck?.metadata)} />,
};

export default videoBlockConfig;
